module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "kp-modular-menu"
  }, [_c('logo'), _vm._v(" "), _c('steps'), _vm._v(" "), _c('model'), _vm._v(" "), _c('button-style'), _vm._v(" "), _c('advanced-config'), _vm._v(" "), _c('span', {
    staticClass: "sidebar_notify__icon",
    class: {
      'notify_topbar_active': _vm.topBarConfig.user.ucode,
      'is-loading': _vm.isLoading
    }
  }, [_vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" "), _c('div', {
    staticClass: "sidebar_notify__label"
  }, [_vm._v(_vm._s(_vm.isLoading ? _vm.$t('general.labels.saving') : 'OK'))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "klickart-loader-container"
  }, [_c('div', {
    staticClass: "klickart-loader"
  })])
}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-448607f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/buttons/Main.vue
 ** module id = 812
 ** module chunks = 1
 **/